import React from 'react'
import './index.scss'

interface MyProps {
  style?: React.CSSProperties
}
const CopyRight: React.FC<MyProps> = ({ style = {} }: MyProps) => {
  return (
    <div className='copyRight-ctr' style={{ ...style }}>
      <div>All rights reserved. 2025</div>
      <div>Crazy Maple Studio Inc.©</div>
    </div>
  )
}

export default CopyRight
